import { render, staticRenderFns } from "./MatomoSetting.vue?vue&type=template&id=41e32166&"
import script from "./MatomoSetting.vue?vue&type=script&lang=ts&"
export * from "./MatomoSetting.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports